import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell, faMicrochipAi, faDesktopArrowDown
} from "@fortawesome/pro-light-svg-icons";

import {
  faMicrosoft
} from "@fortawesome/free-brands-svg-icons";


const items = [
  {
    icon: <FontAwesomeIcon  icon={faBell} size="xl" color='orange'/>,
    title: 'Auto Notification',
    description:
      'Get instant alerts set at a severity level of your choosing with all the information you need to act fast.',
  },
  {
    icon: <FontAwesomeIcon  icon={faMicrosoft} size="xl" color='orange'/>,
    title: 'Regional Azure Deployment',
    description:
      'Maintain data sovereignty by keeping all your data in your tenant in your region.',
  },
  {
    icon: <FontAwesomeIcon  icon={faMicrochipAi} size="xl" color='orange'/>,
    title: 'AI Knowledge Base',
    description:
      'Our AIs are constantly learning. Making sure they are aware of emerging threats and governance requirements.',
  },
  {
    icon: <FontAwesomeIcon  icon={faDesktopArrowDown} size="xl" color='orange'/>,
    title: 'Simple Installation',
    description:
      'Install in seconds and get a complete view in minutes. No consultancy and no hassle.',
  },
];

export default function Content() {
  return (
    <Stack
      sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4, maxWidth: 450 }}
    >
      <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
        {/* <SitemarkIcon /> */}
      </Box>
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}